import React from "react"
import { usePropostas } from "../../../../../../../context/PropostasContext";
import { PropostaData } from "../../../../../../../types/proposta-data-interface";

interface PropostaProps {
  proposta: PropostaData
  contrato: string;
}

export const Proposta = ({ proposta, contrato }: PropostaProps) => {
  const { selectedProposta, getSelectedProposta } = usePropostas()
  return (
    <div className="mb-2 mt-4 flex flex-col  text-sm" key={proposta.id}>
      {
        proposta.tipo === 'AV' ? (<div className="rounded border border-primary text-gray-700 flex gap-2 p-2">
          <input type="radio" name="proposta" id={proposta.id} checked={selectedProposta.id === proposta.id} onChange={() => getSelectedProposta({ ...proposta, contrato })} />
          <label htmlFor={proposta.id} className="font-bold" >Á vista R$ {proposta.valorTotal}</label>
        </div>) : (
          <div className="rounded border border-primary text-gray-700 flex gap-2 p-2">
            <input type="radio" id={proposta.id} name="proposta" checked={selectedProposta.id === proposta.id} onChange={() => getSelectedProposta({ ...proposta, contrato })} />
            <label className="flex flex-col" htmlFor={proposta.id}>
              <strong >Entrada: R$ {proposta.valorEntrada}  +  {proposta.quantidadeParcelas}x de R$ {proposta.valorParcela} </strong>
              <p>Total: R$ {proposta.valorTotal}</p>
            </label>
          </div>
        )
      }
    </div>
  )
}